const state = {
  chat_suporte_visivel: !localStorage.chat_suporte_visivel || localStorage.chat_suporte_visivel === 'S',
};

const getters = {
  getChatSuporteVisivel(state) {
    return state.chat_suporte_visivel;
  },
};

const mutations = {
  setChatSuporteVisivel(state, payload) {
    state.chat_suporte_visivel = payload;
  },
};

const actions = {
  setChatSuporteVisivel(context, mensagem) {
    context.commit("setChatSuporteVisivel", mensagem);
  },
}

export default { namespaced: true, state, mutations, getters, actions }
